<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-panel-header">
    <div class="top-flex">
      <div :class="(panelHeaderData && panelHeaderData.tooltips && panelHeaderData.data.length > 0? 'left' : 'no-data-panel-type-container')">
        <div class="panel-title">{{panelTitle}}</div>
        <el-tooltip v-if="!controller.loading && panelHeaderData.tooltips && panelHeaderData.data.length > 0" popper-class="header-info-poppers" class="item" effect="dark" placement="bottom">
          <div slot="content"><span v-html="panelHeaderData.tooltips"></span></div>
          <div class="icon-info"></div>
        </el-tooltip>
        
        <div style="display: inline-block; width: 5px;"></div>
        <span v-if="controller.controller.selection!='all'" :class="(panelHeaderData.tooltips && panelHeaderData.data.length > 0? 'panel-type' : 'no-data-panel-type')">({{displaySection(controller.controller.selection)}})</span>
      </div>
      <div class="flex-container">
        <wy-panel-header-setting-popup v-show="panelHeaderData.label" ref="settingSection" :controller="controller" />
        <!-- <div class="right">
        <el-dropdown trigger="click">
          <el-tooltip content="configure" placement="bottom">
              <el-button class="setting-icon" plain>
                  <img class="setting-img" src="../../assets/icons/icon_setting.svg" alt="setting icon">
                  <i class="el-icon-arrow-down el-icon--right setting-arrow-down"></i>
              </el-button>
          </el-tooltip>
          <el-dropdown-menu slot="dropdown">
            <div class="gear-panel">
              <div class="gear-header">
                  Configure
                  <img class="close-img" src="../../assets/icons/icon_customer_close.svg" alt="close configure dropdown icon">
              </div>
              <div class="gear-flex">
                <div class="gear-top">
                  View data by:

                  <div class="customer-compare-group-by">
                    <el-select
                    v-model="selectedDateRange"
                    collapse-tags
                    size="mini"
                    style="margin-left: 5px;"
                    class="date-range-dropdown"
                    popper-class="table-filter-dropdown date-range"
                    :popper-append-to-body="false"
                    @change="controller.changeDateRange(selectedDateRange)">
                      <el-option
                        v-for="(item) in dateRangeTypes"
                        :disabled="item.disabled"
                        :key="item.type"
                        :label="item.label"
                        :value="item.type">
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </div>
            </div>
          </el-dropdown-menu>
        </el-dropdown>
        <el-tooltip content="save to my dashboard" placement="bottom">
            <img class="bookmark-img" src="../../assets/icons/icon_bookmark.svg" alt="bookmark icon">
        </el-tooltip>-->
        <!-- <el-tooltip content="move" placement="bottom">
            <img class="move-info" src="../../assets/icons/icon_overview_performance_move.svg" alt="move icon">
        </el-tooltip> -->
      </div>
      
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import WyPanelHeaderSettintPopup from "./wy-panel-header-setting-popup"

  export default Vue.extend({
    name: 'wy-panel-header',
    components: {
        'wy-panel-header-setting-popup': WyPanelHeaderSettintPopup
    },
    props: ["controller", "panelHeaderData", 'panelTitle'],

    methods: {
      displaySection(section) {
        if(section == 'contained') {
          return 'Intents to contain';
        }
        if(section == 'handoff') {
          return 'Intents to handoff';
        }
        return ''
      }
    }

  });
</script>

<style lang="scss">

  .wy-panel-header {
    background-color: #FFF;
    // height: 63px;

    .flex-container {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
    }

    .top-flex{
      display: flex;
      padding: 15px;
      background-color: #FFF;
      padding-bottom: 4px;
      border-bottom: 1px solid #CAD2DA;
      font-size: 18px;
      justify-content: space-between;
      margin-top: 3px;
      height: 42px;
    }
    .bottom-left-stats-small-flex{
      display: flex;
      margin-top: 15px;
      align-items: center;
    }
    .icon-info{
      display: inline-block;
      background: url('../../assets/icons/icon_info_performance_overview.svg') no-repeat;
      width: 20px;
      height: 17px;
      position: relative;
      top: 8px;
      margin-left: 0.25vw;
    }
    .panel-title {
      // font-size: 1.2vw;
      font-size: 18px;
      font-family: Helvetica Neue, Helvetica;
      font-weight: 500;
      color: var(--site-font-secondary-color);
      display: inline-block;
      position: relative;
      top: 4px;
    }
    span.panel-type {
      // padding: 8px;
      font-size: 18px;
      position: relative;
      top: 4px;
    }
    .no-data-panel-type-container{
      display: flex;
      align-items: center;
      margin-bottom: 16px;
    }
    .no-data-panel-type{
      font-size: 18px;
      position: relative;
      top: 4px;
      margin-left: 10px;
    }

    .el-input--mini .el-input__inner {
      height: 31px;
      width: 4.8vw;
      line-height: 1.34vw;
    }
    .setting-arrow-down{
      display: none;
    }
    .el-button.is-plain:hover, .el-button.is-plain:active {
      background: #FFF;
      border: none; 
      color: var(--site-font-tertiary-color);
    }
    .el-button {
      font-family: "Helvetica Neue", Helvetica !important;
      border: none !important;
      font-size: 14.22px;
      color: var(--site-font-tertiary-color);
      font-weight: normal;
      margin-right: 0.5vw;
    }
    img.el-tooltip.move-info {
      width: 30px;
      position: relative;
      cursor: move;
      bottom: 6px;
    }
    .el-dropdown {
      margin-right: 15px;
    }
    .wy-panel-header-setting-popup.right {
      display: flex;
      display: none;
      // visibility: hidden;
    }
    .wy-panel-header-setting-popup.right.show {
      display: flex !important;
      // visibility: visible;
    }
    button.el-button.gear-dropdowns.el-button--default.is-plain.el-dropdown-selfdefine{
      border: none !important;
    }
    .customer-compare-group-by{
      margin-left: 75px;
    }
  }

  .header-info-poppers{
    font-family: Helvetica Neue, Helvetica;
    font-size: 14px;
  }

</style>